import { Box, Button } from "@mui/material";
import { _COLORS } from "../../utils/constants";

export const DeleteImportError = ({ importError, deleteImportError }) => {
  return (
    <>
      <Box display="flex" flexDirection="column" alignItems="center">
        <Button
          variant="contained"
          sx={{ marginTop: 2, backgroundColor: _COLORS.error }}
          onClick={() => deleteImportError(importError)}
        >
          Delete
        </Button>
      </Box>
    </>
  );
};
